<template>
  <div class="index">

  </div>
</template>

<script>
  export default {

    name: "",
    methods: {
      loginPage() {
        this.$router.push("/login");
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Index.vue